import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'

import Axios from 'axios'

import Carousel3d from 'vue-carousel-3d'
Vue.use(Carousel3d)

import router from './router'
import store from './store'

import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import KeycloakUtils from './keycloakUtils'
import Environment from './environment'
import 'buefy/dist/buefy.css'
console.log(Environment);

Axios.defaults.baseURL = __API__
Vue.prototype.$http = Axios
Vue.prototype.$eventHub = new Vue()

Vue.use(Buefy, {
  defaultDayNames: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  defaultMonthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
})


function tokenInterceptor () {
  Axios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    return config
  }, error => {
    return Promise.reject(error)
  })
}


Vue.use(VueKeyCloak, {
  config: {
    authRealm: Environment.authRealm,
    authUrl: Environment.authUrl,
    authClientId: Environment.authClientId,
    logoutRedirectUri: Environment.logoutRedirectUri
  },
  init: {onLoad: 'check-sso'},
  onReady: (keycloakFunction) => {

    window.keycloak=keycloakFunction

    if(keycloakFunction.authenticated){
      KeycloakUtils.setAuthState(keycloakFunction)
    }else{
      KeycloakUtils.validateSesion(window.keycloak).then()
    }
    tokenInterceptor()
    new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App),
      template: '<App/>',
    })

  }
})







// WEBPACK FOOTER //
// ./src/main.js